<template>
  <div class="luckDraw">
    <div class="container">
      <div class="turntable-wrapper">
        <div class="topBg">
          <div class="myReward" @click="toMyReword">
            <span class="title">我的奖品</span>
            <div class="num" v-show="rewardNum != 0">{{ rewardNum }}</div>
          </div>
          <div class="thisTitle">
            <div class="radius left"></div>
            <span>幸运抽奖</span>
            <div class="radius right"></div>
          </div>
        </div>
        <div class="luck-wrapper">
          <div :class="`${item.type}Radius` + ` ${item.position}Radius`" v-for="(item, index) in radiusArr" :key="index"
            :style="{ flexDirection: ((index + times) % 2 == 1 ? `${item.type}-reverse` : '') }">
            <img class="radius" src="../../assets/images/turn/pink.png" />
            <img class="radius" src="../../assets/images/turn/yellow.png" />
            <img class="radius" src="../../assets/images/turn/pink.png" />
            <img class="radius" src="../../assets/images/turn/yellow.png" />
            <img class="radius" src="../../assets/images/turn/pink.png" />
            <img class="radius" src="../../assets/images/turn/yellow.png" />
          </div>
          <ul class="nineGrid">
            <li class="row">
              <div v-for="(n, key) in list.slice(0, 3)" :key="key" :class="index === key ? `active` : ``">
                <div class="wrapper">
                  <div class="imgWrapper">
                    <img class="prize" v-if="n.prize_value != 0" :src="n.prize_image" alt />
                    <div class="thank" v-else>
                      <img src="../../assets/images/turn/thank.png" alt />
                      <span>{{ n.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="mask" :style="{ display: runnig }"></div>
              </div>
            </li>
            <li class="row">
              <div :class="index === 7 ? 'active' : ''">
                <div class="wrapper">
                  <div class="imgWrapper">
                    <img class="prize" v-if="list[7].prize_value != 0" :src="list[7].prize_image" alt />
                    <div class="thank" v-else>
                      <img src="../../assets/images/turn/thank.png" alt />
                      <span>{{ list[7].name }}</span>
                    </div>
                  </div>
                </div>
                <div class="mask" :style="{ display: runnig }"></div>
              </div>
              <div class="getLuck end" v-if="isEnd">
                <div class="imgWrapper">
                  <span class="des">游戏</span>
                  <span class="des">{{ isStart ? '已过期' : '未开始' }}</span>
                </div>
              </div>
              <div class="getLuck" @click="startLottery" v-else>
                <div class="imgWrapper">
                  <span class="title">抽奖</span>
                  <div class="num"><span>剩余{{ score }}次</span></div>
                </div>
              </div>
              <div :class="index === 3 ? 'active' : ''">
                <div class="wrapper">
                  <div class="imgWrapper">
                    <img class="prize" v-if="list[3].prize_value != 0" :src="list[3].prize_image" alt />
                    <div class="thank" v-else>
                      <img src="../../assets/images/turn/thank.png" alt />
                      <span>{{ list[3].name }}</span>
                    </div>
                  </div>
                </div>
                <div class="mask" :style="{ display: runnig }"></div>
              </div>
            </li>
            <li class="row">
              <div v-for="(n, key) in list.slice(4, 7).reverse()" :key="key" :class="index === 6 - key ? `active` : ``">
                <div class="wrapper">
                  <div class="imgWrapper">
                    <img class="prize" v-if="n.prize_value != 0" :src="n.prize_image" alt />
                    <div class="thank" v-else>
                      <img src="../../assets/images/turn/thank.png" alt />
                      <span>{{ n.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="mask" :style="{ display: runnig }"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="myScore">
          <span class="title">每次抽奖消耗{{ icon }}抽奖券</span>
          <span class="score">当前剩余抽奖券：{{ score }}</span>
        </div>
        <div class="rewordRecord">
          <div class="title">中奖纪录</div>
          <div class="line"></div>
          <div class="recordList">
            <div class="record" v-if="record.length > 0">
              <div class="container" id="recordCotainer"
                :style="{ transform: `translateY(-${0.52 * recordIndex}rem)`, transition: 'all .5s' }">
                <div class="item" v-for="(item, index) in record" :key="index">
                  <span class="time">{{ item.create_time }}</span>
                  <span>恭喜{{ item.nick_name }}抽中{{ item.prize_name }}</span>
                </div>
              </div>
            </div>
            <div class="noData" v-if="record.length == 0">暂无中奖纪录</div>
          </div>
        </div>
        <div class="commodityList" v-if="commodityList.length > 0">
          <div class="title">商品列表</div>
          <van-list v-model="loading" :finished="finished" :finished-text="commodityList.length > 0 ? '我已经到底了~' : ''"
            @load="getData" :immediate-check="false" :offset="20">
            <div class="tabbox">
              <div class="tabboxm" v-for="(item, index) in commodityList" :key="index" @click="golistdetail(item.nbr)">
                <div class="tabboxmt">
                  <img class="img" v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt="">
                  <div :class="item.quantity === '0' ? 'noNum' : 'noNum hide'">
                    <img v-lazy="require('../../assets/images/noNum.png')" alt="">
                  </div>
                  <div class="couponNum" v-if="item.gift_ticket_num > 0">{{ item.gift_ticket_num }}抽奖券</div>
                  <img class="sales" v-if="item.start_state == 0" src="../../assets/images/beSale.png" alt="">
                </div>
                <div class="border"></div>
                <div class="tanboxmm1 more-h">
                  {{ item.commodity_name }}
                </div>
                <div class="tanboxmb">
                  <span class="bold"><i>￥</i>{{ item[`${roleText}_price`] }}<span
                      v-if="Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`]) * 100) / 100 != 0">/<i>赚</i>￥{{
                        Math.round((item[`sell_price`]
                          - item[`${roleText.toLowerCase()}_price`]) * 100) / 100 }}</span>
                  </span>
                </div>
                <div class="couponbox">
                  <span class="tanboxmbspan">￥{{ item.old_price }}</span>
                  <span :class="item.is_use_coupon == '0' ? 'coupon1 hide' : 'coupon1'">可用券</span>
                </div>
              </div>
            </div>
          </van-list>
        </div>
        <div class="appDesc" v-if="pageType == 'app'">温馨提示：上述活动苹果公司不是赞助商，并且苹果公司不会以任意形式参与其中。</div>
      </div>
    </div>

    <!--中奖弹窗-->
    <van-popup v-model="rewardShow" style="border-radius: 0.2rem;">
      <div class="rewardBox">
        <img class="close" @click="rewardShow = false" src="./../../assets/images/turn/close.png" alt />
        <img class="text" src="./../../assets/images/turn/text.png" alt />
        <div class="commodity"><img :src="reward.prize_image" alt /></div>
        <div class="notice">
          <span>恭喜您获得</span>
          <span style="white-space: nowrap; display: flex;">
            <span>"</span>
            <span class="name">{{ reward.prize_name }}</span>
            <span>"</span>
          </span>
        </div>

        <div class="commodity1" v-if="showQRCode">
          <img src="../../assets/images/turn/wxImg.png" alt />
          <p>扫码或者添加微信：17789733517领红包</p>
        </div>

        <div class="button grey" v-if="reward.prize_type > 1">
          <span class="buttonText" @click="toMyReword">
            <div>已自动发放</div>
          </span>
          <span class="buttonBg"></span>
        </div>
        <div class="button" v-else>
          <span class="buttonText" @click="toMyReword">
            <div>立即领奖</div>
          </span>
          <span class="buttonBg"></span>
        </div>
      </div>
    </van-popup>

    <!--未中奖弹窗-->
    <van-popup class="noBg" v-model="noRewardShow">
      <div class="noRewardBox">
        <div class="button">
          <span class="buttonText" @click="startLottery">
            <div>再抽一次</div>
          </span>
          <span class="buttonBg"></span>
        </div>
        <div class="closeTop" @click="noRewardShow = false"></div>
        <div class="closeRight" @click="noRewardShow = false"></div>
        <div class="closeBtn" @click="noRewardShow = false"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      title: "积分抽奖",
      index: -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 50, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      click: true,
      selected: false, // 中没中奖？
      showToast: false,
      rewardShow: false,
      noRewardShow: false,
      list: [{}, {}, {}, {}, {}, {}, {}, {}],
      radiusArr: [
        // 滚动点配置项
        { type: "row", position: "top" },
        { type: "row", position: "bottom" },
        { type: "column", position: "right" },
        { type: "column", position: "left" }
      ],
      icon: 0, //每次消耗积分
      remain_num: 0, //每天几次
      score: 0, // 拥有多少积分
      record: [], // 中奖纪录
      recordIndex: 0, //滚动位置
      runnig: "none",
      reward: {}, // 中奖对象
      showQRCode: false,
      timers: null,
      rewardNum: 0, // 奖品数量
      isEnd: true, // 是否关闭游戏
      isStart: false, // 是否小于开始时间
      pageType: '',
      gameNbr: '',

      loading: false,
      isLoading: false,
      finished: true,
      pageIndex: 0,
      numPerPage: 10,
      commodityList: [],
      roleText: 'sell',
      scroll: 0,
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    toMyReword() {
      if (this.pageType == 'xcx') {
        wx.miniProgram.navigateTo({ url: "/pages/myprize/myprize" });
      } else if (this.pageType == 'app') {
        let data = {
          command: 'jump',
          payload: {
            webView: 'MyReward',
            params: {
              type: 'game',
              gameNbr: this.gameNbr
            }
          },
        };
        window.postMessage(JSON.stringify(data), '*');
      } else {
        this.$router.push({ path: "/myReward", query: { gameNbr: this.gameNbr, supNbr: this.userInfo.nbr } });
      }
    },
    // 开始抽奖
    lotteryAjax() {
      this.$commonPost({
        jydm: "flow_90001",
        flow_90001: {
          user_nbr: this.userInfo.nbr,
          game_nbr: this.gameNbr,
        }
      })
        .then(response => {
          this.reward = response;
          this.showQRCode = response.prize_name.indexOf('一等奖')>=0||response.prize_name.indexOf('二等奖')>=0||response.prize_name.indexOf('三等奖')>=0
          this.getUser();
          this.startRoll();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    startLottery() {
      if (!this.click) {
        return;
      }
      this.rewardShow = false;
      this.noRewardShow = false;
      this.speed = 200;
      this.click = false;
      this.lotteryAjax();
    },
    getData(bool) {
      if (bool) this.pageIndex = 0;
      this.$commonPost({
        jydm: "flow_70061",
        flow_70061: {
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
          is_ticket: 1,
        }
      })
        .then(resp => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            let arr = [];
            if (resp.commodityList) {
              if (resp.commodityList.commodity.length > 0) {
                arr = resp.commodityList.commodity;
              } else {
                arr.push(resp.commodityList.commodity);
              }
            }
            this.commodityList = (bool ? [] : this.commodityList).concat(arr);
            if (arr.length < 10) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.isLoading = false;
            this.loading = false;
            this.pageIndex += 1;
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getUserRole() {
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          if (response.role == 0 || response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    // 开始转动
    startRoll() {
      let that = this;
      this.runnig = "block";
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.prize = -1;
        this.times = 0;
        setTimeout(() => {
          this.click = true;
          this.runnig = "none";
          if (this.selected) {
            that.rewardShow = true;
          } else {
            that.noRewardShow = true;
          }
          this.getRewardNum();
        }, 1000);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 获得一个中奖位置
          let nbr = that.reward.prize_nbr;
          let list = that.list;
          let oArr = [];
          let selected = false;
          list.map((item, index) => {
            if (item.nbr == nbr) {
              if (item.prize_value == 0) {
                oArr.push(index);
              } else {
                selected = true;
                that.prize = index;
              }
            }
          });
          if (!selected) {
            that.prize = oArr[Math.round(Math.random() * (oArr.length - 1))];
            console.log(that.prize);
          }
          that.selected = selected;
          console.log("你中的是" + that.reward.prize_name);
        } else if (
          this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) ||
            this.prize === this.index + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },
    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    },
    checkName(name) {
      let result = "";
      let nameArr = name.split("");
      let length = name.replace(/[\u0391-\uFFE5]/g, "aa").length;
      if (length > 4) {
        result = nameArr[0] + "**" + nameArr[nameArr.length - 1];
      } else {
        result = name;
      }
      return result;
    },
    getCommdity() {
      // 获取抽奖商品
      this.$commonPost({
        jydm: "flow_90006",
        flow_90006: {
          game_nbr: this.gameNbr,
        }
      })
        .then(response => {
          let arr = [];
          let obj = {};
          if (response.resp_code == 0 && response.resp_result == 0) {
            if (response.game) {
              let length = response.game.length;
              if (length) {
                arr = response.game;
              } else {
                arr.push(response.game);
              }
              arr.map((item, index) => {
                if (item.prize_value == 0) {
                  obj = item;
                }
              });
              length = arr.length;
              if (length < 8) {
                let count = 8 - length;
                for (let i = 0; i < count; i++) {
                  let thisIndex = Math.ceil(Math.random() * (length + i));
                  arr.splice(thisIndex, 0, obj);
                }
              }
            }
            if (response.ticket_num) {
              this.icon = parseFloat(response.ticket_num);
            }
            let nowTime = new Date().getTime()
            let startTime = new Date(response.create_time).getTime()
            this.isStart = startTime <= nowTime
            this.isEnd = response.active == '1';
            if (this.gameNbr == '10001' && this.isEnd && !this.isStart) {
              this.$toast({
                message: '抽奖大转盘初八(1月29日)才可以使用',
                duration: 2000
              });
            }
          }
          this.list = arr;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getUser() {
      // 用户信息
      this.$commonPost({
        jydm: "flow_90007",
        flow_90007: {
          user_nbr: this.userInfo.nbr,
          game_nbr: this.gameNbr,
        }
      })
        .then(response => {
          if (response.remain_num) {
            this.remain_num = response.remain_num;
            this.score = parseFloat(response.ticket);
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getRecord() {
      // 抽奖记录
      this.$commonPost({
        jydm: "flow_90005",
        flow_90005: {
          page_index: 0,
          num_per_page: 20,
          game_nbr: this.gameNbr,
        }
      })
        .then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if (response.game) {
              if (response.game.length > 1) {
                arr = response.game;
              } else {
                arr.push(response.game);
              }
            }
          }
          arr.map(item => {
            if (item.nick_name) {
              item.nick_name = this.checkName(item.nick_name);
            }
          });
          if (response.total_rows > 8) {
            arr = arr.concat(arr);
            this.record = arr;
            setTimeout(() => {
              this.recordRun(arr);
            }, 200);
          } else {
            this.record = arr;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getRewardNum() {
      this.$commonPost({
        jydm: "flow_90008",
        flow_90008: {
          user_nbr: this.userInfo.nbr,
          game_nbr: this.gameNbr,
          state: 0,
          page_index: 0,
          num_per_page: 1,
        }
      })
        .then(response => {
          this.rewardNum = response.total_rows;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    golistdetail(nbr) {
      this.$router.push({ path: "/listdetail", query: { nbr: nbr, supNbr: this.userInfo.nbr } });
    },
    recordRun(record) {
      let recordCotainer = document.getElementById("recordCotainer");
      this.timers = setInterval(() => {
        let recordIndex = this.recordIndex;
        if (record.length / 2 == recordIndex) {
          recordCotainer.style.transition = "all 0s";
          recordCotainer.style.transform = "translateY(0)";
          this.recordIndex = 0;
          setTimeout(() => {
            recordCotainer.style.transition = "all .5s";
            this.recordIndex += 1;
          }, 0);
        } else {
          recordCotainer.style.transition = "all .5s";
          this.recordIndex += 1;
        }
      }, 2500);
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  created() {
    let option = {
      title: '有米@' + this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl
    };
    this.weChatShare(option);
  },
  activated() {
    this.getUser();
    this.getRecord();
    this.getRewardNum();
    window.scrollTo(0, this.scroll);
  },
  mounted() {
    document.title = this.title;
    let type = this.getUrlParam("type");
    let gameNbr = this.getUrlParam("gameNbr");
    this.pageType = type
    this.gameNbr = gameNbr || '10000'
    if (type) {
      let userNbr = this.getUrlParam("userNbr");
      let userInfo = {
        nbr: userNbr
      };
      this.senduserInfo(userInfo);
    } else {
      if (!(this.userInfo && this.userInfo.nbr)) {
        return this.$router.replace({ path: '/index' });
      }
    }
    this.getCommdity();
    this.getUserRole();
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    if (this.timers) {
      clearInterval(this.timers);
    }
    this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
};
</script>
<style scoped lang='stylus'>
.noBg {
  background-color: transparent !important;
  left: 1.22rem;
  transform: translate3d(0%, -59%, 0);
}
.container >>> .van-list__finished-text{
  color: #fff;
}
</style>
<style scoped lang='less'>
.luckDraw {
  .turntable-wrapper::-webkit-scrollbar {
    display: none;
  }

  .turntable-wrapper {
    position: relative;
    background: #e90c0c;

    .topBg {
      width: 100%;
      position: relative;
      margin-bottom: 0.2rem;
      background: url(../../assets/images/turn/topBg.png) no-repeat;
      height: 4rem;
      background-size: contain;

      .myReward {
        position: absolute;
        top: 0.32rem;
        right: 0;
        width: 1.88rem;
        height: 0.68rem;
        display: flex;
        align-items: center;
        background-image: linear-gradient(43deg, #FFFFFF 0%, #FFFFFF 100%);
        border-top-left-radius: 0.34rem;
        border-bottom-left-radius: 0.34rem;

        .title {
          position: absolute;
          font-size: 0.56rem;
          color: #D60A21;
          letter-spacing: 2px;
          font-weight: 600;
          left: 0.34rem;
          top: 50%;
          white-space: nowrap;
          transform: translateY(-50%) scale(0.5);
          transform-origin: 0%;
        }

        .num {
          min-width: 0.58rem;
          height: 0.58rem;
          position: absolute;
          right: 0.25rem;
          top: 0.04rem;
          color: #fff;
          font-size: 0.48rem;
          font-weight: 500;
          text-align: center;
          box-sizing: border-box;
          border-radius: 0.58rem;
          background: #fe0e4b;
          transform: translateX(50%);
          transform-origin: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 0.12rem;
          transform: scale(0.5) translateX(50%);
          transform-origin: 100% 0;
        }
      }

      .thisTitle {
        text-align: center;
        width: 2.64rem;
        position: relative;
        top: 3.56rem;
        left: 50%;
        transform: translateX(-50%);

        span {
          font-size: 0.36rem;
          color: #fff;
        }

        .radius {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          background: #fff;
        }

        .radius.left {
          left: 0;
        }

        .radius.right {
          right: 0;
        }
      }
    }

    .luck-wrapper {
      width: 6.9rem;
      height: 6.9rem;
      margin: 0 auto;
      position: relative;
      background: url("../../assets/images/turn/nineBg.png");
      background-size: contain;
      border-radius: 0.2rem;

      .radius {
        width: 0.2rem;
        height: 0.2rem;
      }

      .rowRadius {
        position: absolute;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 0.74rem;
        height: 0.26rem;
        box-sizing: border-box;
      }

      .rowRadius.reverse {
        flex-direction: row-reverse;
      }

      .rowRadius.topRadius {
        top: 0;
      }

      .rowRadius.bottomRadius {
        bottom: 0;
      }

      .columnRadius {
        position: absolute;
        top: 0;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
        height: 100%;
        padding: 0.74rem 0;
        width: 0.2rem;
        box-sizing: border-box;
      }

      .columnRadius.reverse {
        flex-direction: column-reverse;
      }

      .columnRadius.leftRadius {
        left: 0;
      }

      .columnRadius.rightRadius {
        right: 0;
      }

      .nineGrid {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 6.18rem;
        height: 6.18rem;
        transform: translate(-50%, -50%);
        border-radius: 0.16rem;

        li {
          height: 1.94rem;
          display: flex;
          margin-top: 0.1rem;

          >div {
            flex: 1;
            margin-right: 0.1rem;
            height: 100%;
            text-align: center;
            position: relative;

            .wrapper {
              width: 100%;
              height: 100%;
              margin: 0;
              background: #968e9b;
              color: #fff;
              border-radius: 0.16rem;

              .imgWrapper {
                height: 1.84rem;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #fff;
                border-radius: 0.16rem;

                .prize {
                  width: 1.6rem;
                  height: 1.6rem;
                  vertical-align: middle;
                  object-fit: cover;
                }

                .thank {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;

                  img {
                    width: 0.92rem;
                    height: 0.92rem;
                    margin-bottom: 0.24rem;
                  }

                  span {
                    font-size: 0.28rem;
                    color: #953c27;
                  }
                }
              }
            }

            .mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0.5;
              border-radius: 0.1rem;
              background-color: #000;
            }
          }

          >div.active {
            .mask {
              display: none !important;
            }
          }

          >div:first-child {
            margin-left: 0.1rem;
          }

          >div.getLuck.end {
            background: #968E9B;

            .imgWrapper {
              background: url("../../assets/images/turn/end.png") !important;
              display: flex;
              align-items: center;
              justify-content: center;

              .des {
                color: #fff;
                font-size: .4rem;
                line-height: .56rem;
                font-weight: 500;
              }
            }
          }

          >div.getLuck {
            background: #93722d;
            border-radius: 0.16rem;

            .imgWrapper {
              height: 1.84rem;
              display: flex;
              align-items: center;
              flex-direction: column;
              background: url("../../assets/images/turn/start.png");
              background-size: contain;
              border-radius: 0.16rem;

              .title {
                font-weight: 600;
                color: #fb3a1c;
                font-size: 0.48rem;
                margin-top: 0.5rem;
              }

              .num {
                margin-top: 0.2rem;
                width: 1.52rem;
                height: 0.4rem;
                background: #fb3a1c;
                border-radius: 0.22rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                  line-height: 0;
                  color: #fff;
                  font-size: 0.56rem;
                  transform: scale(0.5);
                  white-space: nowrap;
                }
              }
            }
          }
        }

        li:last-child {
          margin-bottom: 0.05rem;
        }
      }
    }

    .myScore {
      width: 6.68rem;
      //background: url(../../assets/images/turn/Bitmap.png) no-repeat;
      background: #FF3B3B;
      //background-size: contain;
      border-radius: .1rem;
      height: 1.24rem;
      margin: 0.2rem auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .title {
        font-size: 0.32rem;
        font-weight: bold;
        color: #fff;
      }

      .score {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }

    .rewordRecord {
      width: 6.68rem;
      height: 5.96rem;
      background: #FF3B3B;
      border-radius: 0.22rem;
      margin: 0.2rem auto .3rem;
      position: relative;

      .title {
        width: 100%;
        height: 0.74rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.3rem;
        color: #fff;
        font-weight: 600;
      }

      .line {
        width: 6.2rem;
        height: 0.2rem;
        background: #E90C0C;
        border-radius: 0.1rem;
        position: absolute;
        top: 0.74rem;
        left: 50%;
        transform: translateX(-50%);
      }

      .recordList {
        width: 6rem;
        height: 4.8rem;
        top: 0.84rem;
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        background: #fff;
        border-bottom-left-radius: 0.16rem;
        border-bottom-right-radius: 0.16rem;

        .noData {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.28rem;
          color: #999;
        }

        .record::-webkit-scrollbar {
          display: none;
        }

        .record {
          width: calc(100% - 0.4rem);
          margin: 0.2rem auto 0;
          height: 4.38rem;
          box-sizing: border-box;
          overflow-y: hidden;
          padding-top: 0.2rem;

          .item {
            margin-bottom: 0.2rem;
            width: 100%;
            height: 0.32rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #da4b2d;

            span {
              color: #da4b2d;
              font-size: 0.24rem;
            }

            .time {
              margin-right: 0.24rem;
            }
          }
        }
      }
    }
  }
}

.rewardBox {
  width: 5.82rem;
  /* height: 10.5rem; */
  min-height: 7.5rem;
  padding-bottom: 1.81rem;
  box-sizing: border-box;
  background: url(./../../assets/images/turn/redTopBg.png) no-repeat;
  background-size: 100% 4.33rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .close {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }

  .text {
    width: 2.8rem;
    height: 0.42rem;
    margin-top: 0.6rem;
  }

  .commodity {
    width: 3.7rem;
    height: 2.06rem;
    background: url(./../../assets/images/turn/star.png) no-repeat;
    background-size: 100%;
    position: relative;
    margin-top: .5rem;
    margin-left: -.45rem;
    img {
      width: 2.14rem;
      height: 2.14rem;
      position: absolute;
      top: 0;
      left: 1.23rem;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .commodity1 {
    /* width: 3rem; */
    height: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      font-size: .27rem;
    }
    img {
      width: 2.14rem;
      height: 2.14rem;
      object-fit: cover;
      margin-bottom: .1rem;
    }
  }

  .button {
    position: absolute;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);

    &.grey {
      .buttonText {
        background-image: linear-gradient(-180deg, #ddd 0%, #ddd 100%) !important;
      }

      div {
        color: #fff !important;
      }

      .buttonBg {
        background: #b4b4b4 !important;
      }
    }

    .buttonText {
      position: absolute;
      bottom: 0.08rem;
      width: 3.19rem;
      height: 0.7rem;
      background-image: linear-gradient(-180deg, #ffc904 0%, #fff743 100%);
      border-radius: 0.35rem;
      display: inline-block;
      text-align: center;
      line-height: 0.7rem;
      font-size: 0.3rem;
      color: #ef3342;
      font-weight: bold;
      z-index: 4;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.4rem;
        transform: scale(0.5);
        font-size: 0.6rem;
        color: #ef3342;
        font-weight: bold;
        transform-origin: top;
      }
    }

    .buttonBg {
      z-index: 2;
      width: 3.19rem;
      height: 0.7rem;
      background: #f3b500;
      border-radius: 0.35rem;
      display: inline-block;
    }
  }

  .notice {
    width: 5rem;
    height: 0.84rem;
    margin-top: 1.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    span {
      font-size: 0.3rem;
      color: #333;
      font-weight: bold;
      line-height: 0.42rem;

      .name {
        max-width: 4.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }

  }
}

.noRewardBox {
  width: 5.5rem;
  height: 5.66rem;
  background: url(./../../assets/images/turn/thankPp.png) no-repeat;
  background-size: 100%;
  position: relative;

  .button {
    position: absolute;
    // bottom: 0.3rem;
    bottom: -1.5rem;
    left: 0.94rem;

    &.grey {
      .buttonText {
        background-image: linear-gradient(-180deg, #ddd 0%, #ddd 100%) !important;
      }

      div {
        color: #fff !important;
      }

      .buttonBg {
        background: #b4b4b4 !important;
      }
    }

    .buttonText {
      position: absolute;
      bottom: 0.08rem;
      width: 3.19rem;
      height: 0.7rem;
      background-image: linear-gradient(-180deg, #ffc904 0%, #fff743 100%);
      border-radius: 0.35rem;
      display: inline-block;
      text-align: center;
      line-height: 0.7rem;
      z-index: 4;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.4rem;
        transform: scale(0.5);
        font-size: 0.6rem;
        color: #ef3342;
        font-weight: bold;
        transform-origin: top;
      }
    }

    .buttonBg {
      z-index: 2;
      width: 3.19rem;
      height: 0.7rem;
      background: #f3b500;
      border-radius: 0.35rem;
      display: inline-block;
    }
  }

  .closeBtn {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    position: absolute;
    right: 0rem;
    top: 0.2rem;
  }

  .closeTop {
    position: absolute;
    width: 100%;
    height: 0.5rem;
    top: 0;
  }

  .closeRight {
    position: absolute;
    width: 0.3rem;
    height: calc(100% - 0.5rem);
    right: 0;
    top: 0.5rem;
  }
}

.appDesc {
  width: 6.68rem;
  margin: 0 auto .3rem;
  line-height: 1.5;
  font-size: .24rem;
  color: #fff;
  font-weight: 500;
}

.bold {
  font-weight: bold;
}

.tabbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.commodityList {
  .title {
    font-size: .36rem;
    color: #fff;
    font-weight: 500;
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: .3rem;
    margin-top: 0.4rem;

    &::after {
      content: '';
      position: absolute;
      right: 2.43rem;
      width: .2rem;
      height: 0.2rem;
      border-radius: 50%;
      background: #fff;
    }

    &::before {
      content: '';
      position: absolute;
      left: 2.43rem;
      width: .2rem;
      height: 0.2rem;
      border-radius: 50%;
      background: #fff;
    }
  }
}

.tabboxm {
  margin-top: 0.18rem;
  width: 3.42rem;
  height: 5.34rem;
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
  border: 1px solid #dddddd;
  position: relative;
}

.border {
  width: 3.26rem;
  height: 0.019rem;
  border: 1px solid #dddddd;
  border: 0;
  margin-left: 0.08rem;
}

.border::before {
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 200%;
  width: 200%;
  transform-origin: 0 0;
  border: 1px solid #DDDDDD;
}

.tabboxm:nth-of-type(2n) {
  margin-left: 0.16rem;
}

.tabboxm:nth-of-type(2n - 1) {
  margin-left: 0.24rem;
}

.tabboxmt {
  position: relative;
}

.tabboxm .noNum {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.3);
  width: 100%;
  height: 100%;
}

.tabboxm .noNum img {
  width: 3rem;
  height: 2.3rem;
}

.couponNum {
  position: absolute;
  background-image: url(../../assets/images/turn/couponNum.png);
  background-size: cover;
  width: .9rem;
  height: 0.3rem;
  right: 0;
  top: .19rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: .2rem;
  white-space: nowrap;
  font-weight: 400;
}

.hide {
  display: none !important;
}

.tabboxmt .img {
  width: 3.42rem;
  height: 3.43rem;
  object-fit: cover;
}

.tabboxmt .sales {
  width: 1.16rem;
  height: 0.3rem;
  position: absolute;
  bottom: -0.15rem;
  left: 0.1rem;
  z-index: 9;
}

.tanboxmm1 {
  width: 3.22rem;
  line-height: 0.32rem;
  height: 0.62rem;
  margin: 0 0.1rem;
  font-size: 0.24rem;
  margin-top: 0.2rem;
  color: #333333;
}

.tanboxmm2 {
  line-height: 0.32rem;
  margin: 0 0.24rem;
  margin-top: 0.15rem;
  font-size: 0.22rem;
  color: #999;
}

.tanboxmb {
  margin-top: 0.2rem;
  line-height: 0.33rem;
  overflow: hidden;
}

.tanboxmb span:nth-of-type(1) {
  color: #333;
  font-size: 0.3rem;
  margin-left: 0.08rem;
}

.tanboxmb span:nth-of-type(1) i:nth-of-type(1) {
  font-size: 0.24rem;
  color: #333333;
}

.tanboxmb span:nth-of-type(1) span:nth-of-type(1) {
  font-size: 0.24rem;
  color: #E52B25;
  margin-left: 0.04rem;
}

.tanboxmb span:nth-of-type(1) span:nth-of-type(1) i:nth-of-type(1) {
  font-size: 0.24rem;
  color: #E52B25;
  margin-left: 0.04rem;
}

.tanboxmbspan {
  font-size: 0.24rem;
  text-decoration: line-through;
  color: #666;
  margin-left: 0.08rem;
}

.tanboxmb span i {
  font-size: 0.2rem;
}

.couponbox {
  margin-top: 0.06rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.coupon1 {
  width: 0.9rem;
  height: 0.31rem;
  color: #f53547;
  font-size: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(../../assets/images/FFF1F2.png) no-repeat;
  background-size: 0.9rem 0.3rem;
  position: absolute;
  right: 0;
  bottom: 0.2rem;
}

.coupon {
  background: #fff1f2;
  color: #f53547;
  font-size: 0.18rem;
  padding: 0.02rem 0.07rem;
  border-radius: 0.04rem;
  position: relative;
  top: -0.04rem;
}

.coupon.style1 {
  border-radius: 0.04rem;
  font-size: 0.18rem;
  position: static;
  display: inline-block;
  padding: 0.06rem 0.13rem;
}

.tipModalBox {
  width: 5.5rem;
  height: 5.66rem;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index/turn.vue